// Progress indicator - building anticipation
import FeedbackPage from '@/components/FeedbackPage'

export default function PersonalizationProgressPage() {
  return (
    <FeedbackPage
      emoji="⚙️"
      title="pages.onboarding.personalizationProgress.title"
    />
  )
}
